// extracted by mini-css-extract-plugin
export default {"lstore_title":"styles_lstore_title__uTtcd","section_title":"styles_section_title__89vru"};